var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowthGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.761,
    height: 43.697,
    viewBox: "0 0 43.761 43.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_128_1",
    "data-name": "Component 128 \\u2013 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M3,14V26.827A4.28,4.28,0,0,0,7.276,31.1H20.1V14H3Z",
    transform: "translate(-0.862 11.594)",
    fill: "#ffca3a",
    stroke: "#111",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M13,14V31.1H25.828A4.28,4.28,0,0,0,30.1,26.827V14H13Z",
    transform: "translate(10.518 11.594)",
    fill: "#ffca3a",
    stroke: "#111",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M40.485,14.793H33.827a10.686,10.686,0,0,0,2.64-1.875,6.427,6.427,0,0,0,0-9.074,6.572,6.572,0,0,0-9.07,0c-3.5,3.5-3.97,10.087-4.013,10.827,0,.041.017.077.017.12h-.043c0-.041.021-.079.019-.122-.043-.74-.515-7.327-4.015-10.829a6.577,6.577,0,0,0-9.072,0,6.425,6.425,0,0,0,0,9.072,10.7,10.7,0,0,0,2.643,1.875H6.276A4.28,4.28,0,0,0,2,19.067v6.414H21.242V16.929h4.276v8.552H44.761V19.067A4.28,4.28,0,0,0,40.485,14.793Zm-27.168-4.9a2.139,2.139,0,0,1,3.025-3.025c1.261,1.261,2,3.523,2.39,5.411C16.849,11.886,14.57,11.146,13.317,9.893Zm14.712,2.39c.393-1.888,1.129-4.152,2.39-5.414a2.138,2.138,0,1,1,3.023,3.023C32.181,11.156,29.916,11.892,28.029,12.283Z",
    transform: "translate(-2 -2.029)",
    fill: "#ffca3a",
    stroke: "#111",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthGift);
export default __webpack_public_path__ + "static/media/growth-gift.7885904efe213e576247fc06f9af56be.svg";
export { ForwardRef as ReactComponent };